<div data-test-id="unauthorized-wrapper"  *transloco="let t; read: 'unauthorized'" class="m-0 d-flex align-items-center flex-column">
  <div data-test-id="unauthorized-image-wrapper"  class="image mt-5">
    <img data-test-id="unauthorized-image"  class="h-100 w-100" src="assets/images/user-accessed-unauthorized-page.png" alt="Ouch!" srcset="" />
  </div>
  <div data-test-id="unauthorized-message-wrapper"  class="message mt-5 px-5">
    <span data-test-id="unauthorized-message__sentence-1"  class="message__sentence-1 text-danger font-weight-bold">
      {{ t("ouchText") }}
    </span>
    <span data-test-id="unauthorized-message__sentence-2"  class="message__sentence-2">
      {{ t("noAccessMessage") }}
    </span>
  </div>
  <div data-test-id="unauthorized-button-container"  class="button-container my-5">
    <button data-test-id="unauthorized-logout-btn"  type="button" class="btn btn-synlab w-100" (click)="logout()">{{ t("logoutButton") }}</button>
  </div>
</div>
